/**
 * Définit globalement le user
 * @type {string}
 */
export const USER_SET_USER = 'setUser'
